var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import styled, { keyframes } from "styled-components";
import { colorFromTheme, safeElement } from "../../../utils";

var Spinner = function Spinner(_ref) {
  var color = _ref.color,
      bgColor = _ref.bgColor,
      restProps = _objectWithoutProperties(_ref, ["color", "bgColor"]);

  return React.createElement(
    Outer,
    _extends({ $as: "span", bgColor: colorFromTheme(bgColor) }, restProps),
    React.createElement(
      Svg,
      { viewBox: "20 20 60 60", className: "loading" },
      React.createElement(Path, {
        className: "loading",
        color: color,
        d: " M 25, 50 a 25,25 0 1,1 50,0 a 25,25 0 1,1 -50,0 "
      })
    )
  );
};

export { Spinner };
Spinner.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  loading: PropTypes.bool
} : {};
Spinner.defaultProps = {
  color: "coreWhite",
  loading: true
};

var Outer = styled(safeElement()).withConfig({
  displayName: "Spinner__Outer",
  componentId: "cftzyp-0"
})(["position:absolute;height:70%;width:100%;"]);

var rotate = keyframes(["0%{transform:rotate(0deg)}100%{transform:rotate(-360deg)}"]);

var Svg = styled.svg.withConfig({
  displayName: "Spinner__Svg",
  componentId: "cftzyp-1"
})(["height:100%;width:100%;overflow:visible;transform-origin:50% 50%;&.loading{animation:", " 2s ease-in-out infinite;}"], rotate);

var strokDashArray = keyframes(["0%{stroke-dasharray:160;stroke-dashoffset:0;}50%{stroke-dasharray:160;stroke-dashoffset:160;}100%{stroke-dasharray:160;stroke-dashoffset:320;}"]);

var Path = styled.path.withConfig({
  displayName: "Spinner__Path",
  componentId: "cftzyp-2"
})(["stroke:", ";fill:none;stroke-width:7px;stroke-linecap:round;stroke-dasharray:165;stroke-dashoffset:165;&.loading{animation:", " 2s -1s ease-in-out infinite;}"], function (props) {
  return props.color;
}, strokDashArray);